import React, { useContext } from "react";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import CollapseComponent from '../../components/Schedule/CollapseComponent';
import AuthContext from "../../context/AuthContext";

const HorizontalComponent = (props) => {
  const { showDay, onRowSelectionModelChange, SelectedEmp, expandAll, handleExpandChange, permission,
    onOpenModal, anyExpanded, handleRightClick, dayData, nightData, reformatColumns, is_dn_deparment, setIsNightShift, mode2 , enableMultiSelect} = props

  const { v3Data } = useContext(AuthContext);

  const checkboxSelectionEnabled = (permission?.includes('Emp_Auth') && (v3Data?.V3_DEFAULT_MULTI_CHECKBOX_SCHEDULE ? enableMultiSelect : true)) ? true : false;
  const safeSelectionModel = checkboxSelectionEnabled ? SelectedEmp : (SelectedEmp?.slice(0, 1) ?? []);

  return (
    <div onContextMenu={handleRightClick}
      style={{
        borderBottom: '1px solid #cccccc',
        marginTop: mode2 === '24' ? '10px' : '0px'
      }}>
      <Grid container>
        <Grid item xs={6} sx={{ pr: 1 }}>
          <Box>
            {showDay && dayData && dayData.dayEmployee &&
              Object.values(dayData.dayEmployee).map((station) => (
                <CollapseComponent
                  fontChanges={true}
                  key={station.name}
                  rows={station.employees}
                  columns={reformatColumns(station.notAbsentDay, station.totalDay , null, null, true)}
                  name={station.name}
                  onRowSelectionModelChange={onRowSelectionModelChange}
                  rowSelectionModel={safeSelectionModel}
                  open={expandAll}
                  onExpandChange={handleExpandChange}
                  checkboxSelection={checkboxSelectionEnabled}
                  onOpenModal={onOpenModal}
                  showHeader={false}
                  is_dn_deparment={is_dn_deparment}
                  setIsNightShift={setIsNightShift}
                  mode2={mode2}
                  page = {'schedule-page'}
                />
              ))
            }
            {dayData && dayData.stations &&
              Object.values(dayData.stations).map((station) => (
                <CollapseComponent
                  fontChanges={true}
                  key={station.name}
                  rows={station.employees}
                  columns={reformatColumns(station.notAbsentDay, station.totalDay, station.notAbsentNight, station.totalNight, true , station.minStaffDay , station.minStaffNight)}
                  name={station.name}
                  onRowSelectionModelChange={onRowSelectionModelChange}
                  rowSelectionModel={safeSelectionModel}
                  open={Object.keys(dayData.stations).length < 1 ? true : false || expandAll}
                  minHeightRow='auto'
                  onExpandChange={handleExpandChange}
                  checkboxSelection={checkboxSelectionEnabled}
                  onOpenModal={onOpenModal}
                  showHeader={false}
                  is_dn_deparment={is_dn_deparment}
                  setIsNightShift={setIsNightShift}
                  mode2={mode2}
                  page = {'schedule-page'}
                  minimumDayStaff = {station.minStaffDay}
                  isNightShift={false}
                />
              ))}
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box>
            {/* {showDay && nightData && nightData.dayEmployee &&
              Object.values(nightData.dayEmployee).map((station) => (
                <CollapseComponent
                  key={station.name}
                  rows={station.employees}
                  columns={reformatColumns(station.notAbsentDay, station.totalDay, null, null, false)}
                  name={station.name}
                  onRowSelectionModelChange={onRowSelectionModelChange}
                  rowSelectionModel={SelectedEmp}
                  open={expandAll}
                  onExpandChange={handleExpandChange}
                  checkboxSelection={permission && permission.includes('Emp_Auth') ? true : false}
                  onOpenModal={onOpenModal}
                  showHeader={false}
                  is_dn_deparment={is_dn_deparment}
                  setIsNightShift={setIsNightShift}
                  mode2={mode2}
                  page = {'schedule-page'}
                />
              ))
            } */}
            {nightData && nightData.stations &&
              Object.values(nightData.stations).map((station) => (
                <CollapseComponent
                  key={station.name}
                  rows={station.employees}
                  columns={reformatColumns(station.notAbsentDay, station.totalDay, station.notAbsentNight, station.totalNight, false , station.minStaffDay, station.minStaffNight)}
                  name={station.name}
                  onRowSelectionModelChange={onRowSelectionModelChange}
                  rowSelectionModel={safeSelectionModel}
                  open={Object.keys(nightData.stations).length < 1 ? true : false || expandAll}
                  minHeightRow='auto'
                  onExpandChange={handleExpandChange}
                  checkboxSelection={checkboxSelectionEnabled}
                  onOpenModal={onOpenModal}
                  showHeader={false}
                  is_dn_deparment={is_dn_deparment}
                  setIsNightShift={setIsNightShift}
                  mode2={mode2}
                  page = {'schedule-page'}
                  minimumDayStaff = {station.minStaffDay}
                  minimumNightStaff = {station.minStaffNight}
                  isNightShift={true}
                  fontChanges={true}
                />
              ))}
          </Box>
        </Grid>
      </Grid>
    </div>
  )
}

export default HorizontalComponent;